import { Component, NgZone, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
// import { any } from '../../../../node_modules_manashati/codelyzer/util/function';
import { CommonService } from '../../Services/common.service';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

import { UpdateBalanceService } from '../../Services/update-balance.service'

import { DataManipService } from '../../Services/data-manip.service';
import { navItems } from '../../_nav';
// import { createConsoleLogger } from '../../../../node_modules_manashati/@angular-devkit/core/node';
import { DashboardComponent } from '../../views/dashboard/dashboard.component'
import { WalletService } from '../../Services/wallet.service';

import { Subscription } from 'rxjs';
import {
  Event, NavigationStart, RoutesRecognized,
  RouteConfigLoadStart, RouteConfigLoadEnd,
  NavigationEnd, NavigationCancel, NavigationError, GuardsCheckStart, ChildActivationStart, ActivationStart, GuardsCheckEnd, ResolveStart, ResolveEnd, ChildActivationEnd, ActivationEnd, Scroll
} from '@angular/router';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
import { HelperService } from '../../Services/helper.service';

// const razerpaykey_Id = "rzp_test_YJpYX80CozUKWx";//Test
 const razerpaykey_Id="rzp_live_tMg4Fx116WmCb0";//Live


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {

  public dashboardComp: DashboardComponent;
  public sidebarMinimized = false;
  public navItems = navItems;

  public setDefalutFlagForPayment:string = "N";
  public isGiftTestFlag:string = "";

  @ViewChild('walletTopUpModal', { static: false }) public walletTopUpModal: ModalDirective;
  @ViewChild('changePasswordModal', { static: false }) public changePasswordModal: ModalDirective;
  @ViewChild('walletTopUpAfterSuccessModal', { static: false }) public walletTopUpAfterSuccessModal: ModalDirective;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  
  page: string = "";
  currentPassword: string = "";
  newPassword: string = "";
  confPassword: string = "";
  passwordMatch: boolean = false;
  confirmPassErrMsg: string = "";
  changePassMsg: string = "";
  showLoader: boolean = false;
  userID: any;
  razorpayObject;
  razorOrderId;
  walletAmount;
  wallettext = "";
  message:string = "";
  amountToaddinwallet: any;
  typeForPassword: string = 'password';
  typeForConPassword: string = 'password';
  typeForCurrPassword: string = 'password';
  year = new Date().getFullYear();
  userimage: string = '';
  incorrectCurrentPassError:string = "";
  amount = 0
  options = {

    "key": razerpaykey_Id,
    "amount": "2000",
    "currency": "INR",
    "name": "pravin",
    "description": "Test",
    "image": "https://media.geeksforgeeks.org/wp-content/uploads/20210806114908/dummy-200x200.png",
    "order_id": "order_HdPuQW0s9hY9AU",
    "callback_url": this.configSetting.getBaseUrl()+"orderpayments/verifyOrder",
    "prefill": {
      //Here we are prefilling random contact
      "contact": "7769837705",
      //name and email id, so while checkout
      "name": "Pravin Pawar",
      "email": "pravin.pawar@viotalworks.com"
    },
    "notes": {
      "description": "TEST",
    },
    "theme": {
      "color": "#2300a3"
    }
  };

  ispaymentSuccess = false;
  private toggle: any;
  //public dashboardComp:DashboardComponent,
  constructor(private helper: HelperService, public zone: NgZone, public walletService: WalletService, public balanceupdate: UpdateBalanceService, public dataManipSrvc: DataManipService, private router: Router,
    private commonServices: CommonService, private configSetting: ConfigSettingService, private encryptService:EncrptDecreptService) {
    this.loadRazorPayScriptFileAsItIsNotLoadedAlready();
    this.amountToaddinwallet = 0;

    if (dataManipSrvc.isadmin) {
      navItems.splice(0, navItems.length);
      navItems.push(
        {
          name: 'My Profile',
          url: '/myprofile',
          icon: 'icon-rocket',
        },
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-speedometer',
          //children:[],
          // badge: {
          //   variant: 'info',
          //   text: 'NEW'
          // }
        },
        {
          name: 'Admin ',
          url: '/admin',
          icon: 'icon-screen-desktop',
          children: [
            {
              name: 'User Management ',
              url: '/usermanagement',
              icon: 'icon-user',

            },
            {
              name: 'Test Management ',
              url: '/testmanagement',
              icon: 'icon-doc',

            },
            {
              name: 'Users Test Details ',
              url: '/testlog',
              icon: 'icon-book-open',

            },

            {
              name: 'Users Topup Details ',
              url: '/topuplog',
              icon: 'fa fa-inr',

            },

          ],
        },
        
      )
    }
    else {
      navItems.splice(0, navItems.length);
      navItems.push(
        {
          name: 'My Profile',
          url: '/myprofile',
          icon: 'icon-rocket',
          //children:[],
          // badge: {
          //   variant: 'info',
          //   text: 'NEW'
          // }
        },
        {
          name: 'Dashboard',
          url: '/dashboard',
          icon: 'icon-speedometer',
          //children:[],
          // badge: {
          //   variant: 'info',
          //   text: 'NEW'
          // }
        },
        // {
        //   name: 'Moodlight Test',
        //   url: '/mood-light-testing',
        //   icon: 'icon-speedometer'
        // },
        // {
        //   name: 'Mind Tendency Test',
        //   url: '/mind-tendency-test',
        //   icon: 'icon-speedometer'
        // }
      );
    }

    router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // * NavigationEnd: When navigation ends successfully.
        // console.log('NavigationEnd --- ', event.url);
        // this.toggleCount++;
        this.toggleMenu();
        this.walletDisplay();
      }
    });
  }

  ngOnInit() {
    // this.helperService.setPageHeader('Dashboard');
    this.walletDisplay();
    // if(this.dataManipSrvc.userimage == "null"){
    //   this.dataManipSrvc.userimage = "";
    // }
  }
  ngAfterViewInit() {
    // this.subscription = this.helperService.getPageHeader()
    // .subscribe(message => {
    //   setTimeout(()=>{this.HeadingText = message['text'];},2);
    // });
    // this.cdr.detectChanges();
    this.toggle = document.getElementsByTagName('body');//document.getElementsByClassName('d-lg-block d-none navbar-toggler');

  }

  async payWithPromise() {
    return new Promise((response, reject) => {
      this.payEvent({ response, reject });

    });
  }

  displaywalletpoppup(page) {
    this.ispaymentSuccess = false;
    if (page == 'directPay') {
      this.payEvent();
      return;
    }
    this.page = page;
    //this.walletService.wallettext="";
    //this.walletService.walletAmount=this.walletAmount;
    //this.walletService.walletDisplay(page);
    this.walletTopUpModal.show();

    this.walletDisplay();

  }
  walletDisplay() {
    // console.log("wallet");

    this.userID = this.dataManipSrvc.userId;
    let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/getWalletBalance";
    let param = {  }
    this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
      if (successResp['errorCode'] == "000000") {
        this.walletAmount = successResp['Data'][0]['walletbalance'];
  //      console.log(this.walletAmount);
        this.dataManipSrvc.walletamount = this.walletAmount;
        //this.dashboardComp.balance=this.walletAmount;
        // this.dashboardComp.balance=this.walletAmount;

      }
    });
    //this.walletTopUpModal.show();
    //return this.walletAmount;


  }
  beforepay() {
    // console.log("Before Pay")
    this.walletTopUpModal.hide()

    this.payEvent();
  }
  payEvent(promiseObbj = null) {
    console.log("In Pay")
    //this.walletTopUpModal.hide();

    this.showLoader = true;
    this.changePassMsg = "";
    this.confirmPassErrMsg = "";

    let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/createOrder";
    let body = {
      "amount": parseInt(this.amountToaddinwallet) * 100,
      "currency": "INR",
      "receipt": "order_rcptid_11",
      "notes": {}
    }
    this.amount = parseInt(this.amountToaddinwallet);
    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      // if (successResp['errorCode'] == "000000") {
      //console.log("Set Password .....", JSON.stringify(successResp));       
      this.razorOrderId = successResp["id"];
      //  this.options["order_id"] = this.razorOrderId;
      //  this.razorpayObject = new this.commonServices.nativeWindow.Razorpay(this.options);

      // this.razorpayObject.open();

      this.payWithRazor(promiseObbj);

      //  }
      // else {
      //   this.confirmPassErrMsg = successResp["errorDescription"];
      // }
    })



  }

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
  checkPassword() {
    this.incorrectCurrentPassError = "";
    // if (this.newPassword.length < 8) {
    //   this.incorrectCurrentPassError = "Password must be at least 8 charachters."
    //   this.passwordMatch = false;
    //   return;
    // }
    if (this.confPassword != "") {
      if (this.newPassword != this.confPassword) {
        // this.passCheckImgSrc = "../../../assets/img/form-loader/remove.png";
        this.incorrectCurrentPassError = "New password and confirmation password do not match."
        this.passwordMatch = false;
      }
      else {
        this.incorrectCurrentPassError = "";
        // this.passCheckImgSrc = "../../../assets/img/form-loader/check.png";
        this.passwordMatch = true;
      }
    }
    else {
      //  this.passCheckImgSrc = "";
    }
  }
  clearPassMsg() {
    this.confirmPassErrMsg = "";
  }

  changePasswordEvt() {
    this.showLoader = true;
    this.changePassMsg = "";
    this.confirmPassErrMsg = "";
    let apiUrl = this.configSetting.getBaseUrl() + "user/changePassword";
    let body = {
      "cpl": this.encryptService.encrypt(this.currentPassword),
      "npl": this.encryptService.encrypt(this.newPassword),
      "unl": this.encryptService.encrypt(this.dataManipSrvc.userId+"")
    }

    this.commonServices.postMethod(apiUrl, body).subscribe(successResp => {
      this.showLoader = false;
      if (successResp['errorCode'] == "000000") {
        //console.log("Set Password .....", JSON.stringify(successResp));       
        // this.changePassMsg = "Your Password is changed successfully.";

        // alert("Your Password is changed successfully.");
        // this.router.navigateByUrl('/login');
        
        this.currentPassword = "";
        this.newPassword = "";
        this.confPassword = "";

        this.successModal.show();
        this.message = successResp["errorDescription"];

      }
      else {
        this.incorrectCurrentPassError = successResp["errorDescription"];
      }
    })
  }

  closeModal(){
    this.incorrectCurrentPassError = "";
    this.successModal.hide()
    this.changePasswordModal.hide();
    location.reload();
  }

  restrictChar(eve){
    if (this.helper.restrictCharacters(eve.key)) {
      eve.preventDefault();
    }
  }


  clearMessage(){
    this.incorrectCurrentPassError = "";
  }

  public payWithRazor(promiseObbj = null) {
    console.log("promiseObbj", promiseObbj);

    const options: any = {
      // const key_secret = "Ph7MgPiQKbCKjT0OCjb8n90k";//Live server
      key: razerpaykey_Id,
      //key: 'rzp_test_YJpYX80CozUKWx', //1234
      amount: this.amount * 100, // amount should be in paise format to display Rs 1255 without decimal point
      currency: 'INR',
      name: '', // company name or product name
      description: '',  // product description
      image: './assets/logo.png', // company logo or product image
      order_id: this.razorOrderId, // order_id created by you in backend (uncomment this line when razorpay is in not in test mode)    
      modal: {
        // We should prevent closing of the form when esc key is pressed.
        escape: false,
      },

      prefill: {
        name: this.dataManipSrvc.userName ? this.dataManipSrvc.userName : '',
        email: this.dataManipSrvc.emailId ? this.dataManipSrvc.emailId : 'testing@razorpay.com',
        contact: this.dataManipSrvc.mobileNo ? this.dataManipSrvc.mobileNo : '8888888888',
        'card[number]': '4111111111111111',
        'card[expiry]': '1123',
        'card[cvv]': '123'
      },
      "notes": {
        "address": "Razorpay Corporate Office"
      },
      "theme": {
        "color": "#3399cc"
      }
    };
    let id = this.userID;
    let amt = this.amount;
    let url = this.configSetting.getBaseUrl();
    console.log("before handler");

    options.handler = ((response: any) => {
      //options.response = response;
      
//      console.log("options", options);
//      console.log("start", response);
      
      if (response.razorpay_order_id != undefined || response.razorpay_payment_id != undefined || response.razorpay_signature) {

        let param = {
          "userid": this.userID,
          "razor_orderid": response.razorpay_order_id || this.razorOrderId,
          "razor_paymentid": response.razorpay_payment_id,
          "razorpay_signature": response.razorpay_signature,
          "amount": this.encryptService.encrypt(this.amount+""),
          "paymentstatus": "S"
        }
  console.log("From default layout");
        let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/saveUserPaymentsDetails";
        this.commonServices.postMethod(apiUrl, param,false,{'x-razorpay-signature':''}).subscribe(successResp => {
          // console.log(successResp);
          // console.log(this.walletTopUpModal.isShown)

          // this.closewalletTopUpModal();
          this.walletAmount = successResp["Data"]["walletbalance"];
          //this.dashboardComp.balance=this.walletAmount;
          //this.dashboardComp.balance=this.walletAmount;
          this.wallettext = "Amount Successfully Added in Wallet!!";
          // this.amountToaddinwallet = 0;
          this.ispaymentSuccess = true;
          this.setDefalutFlagForPayment = "Y"
          if(this.isGiftTestFlag == "Y"){
            // this.dashboard.giftTest();
          }
          // console.log(this.walletAmount);
          setTimeout(() => {
            this.clickRZP();
            if (promiseObbj) {
              this.wallettext = '';
              promiseObbj.response(successResp)
            } else {
              this.walletTopUpModal.show();
            }
          }, 30)

        })
      }
//      console.log("end", response);

      // if (error && promiseObbj) {
      //   console.log(error);

      //   promiseObbj.reject()
      //   console.log(error);
        
      // }
    });

    // const check = this.checkIfTheScriptFileIsAlreadyLoadedOrNot();

    // if (!check) {
    //   this.loadRazorPayScriptFileAsItIsNotLoadedAlready();
    // }

    const rzp = new this.commonServices.nativeWindow.Razorpay(options);
    rzp.open();
    //var rzp1 = new Razorpay(options);
    // console.log(this.userID)

    rzp.on('payment.failed', (response: any) => {
      // console.log(response)

      /* alert(response.error.code);
       alert(response.error.description);
       alert(response.error.source);
       alert(response.error.step);
       alert(response.error.reason);
       alert(response.error.metadata.order_id);
       alert(response.error.metadata.payment_id);*/
      let param = {
        "userid": id,
        "razor_orderid": response.error.metadata.order_id,
        "razor_paymentid": "0",
        "amount": amt,
        "paymentstatus": "F"
      }
      // console.log("Sample Data", this.configSetting);
      let apiUrl = this.configSetting.getBaseUrl() + "orderpayments/saveUserPaymentsDetails";
      // console.log(apiUrl)
      ; this.commonServices.postMethod(apiUrl, param).subscribe(successResp => {
        // console.log(successResp);
        //alert("Payment Failed")  
        // this.closewalletTopUpModal();
        this.walletAmount = successResp["Data"]["walletbalance"];
        //  this.balanceupdate.wallet=this.walletAmount;
        this.commonServices.walletamount = this.walletAmount;
        this.clickRZP();
        //this.dashboardComp.balance=this.walletAmount;
        // this.dashboardComp.balance=this.walletAmount;
        this.wallettext = "Payment Fail Try Again";
        this.walletTopUpModal.show();
      })
    });

    rzp.on('', function (response: any) {

    });
    //this.amount=0;
  }
  clickRZP() {
    // console.log("In Click")
    document.getElementById('rpclick').click();
    document.getElementById('removebackdropofrezzarpay').click();
    this.zone.run(() => {
      // console.log('zone');

    })
  }
  closewalletTopUpModal() {
    // console.log("helo");
    this.amountToaddinwallet = 0;
    this.wallettext = "";
    this.balanceupdate.updateBalance(this.page);
    this.walletTopUpModal.hide();

  }


  checkIfTheScriptFileIsAlreadyLoadedOrNot = () => {

    try {
      const rzp = new this.commonServices.nativeWindow.Razorpay({});
      return true;
    }
    catch (exp) {
      return false;
    }
  }

  loadRazorPayScriptFileAsItIsNotLoadedAlready = () => {
    const node = document.createElement('script');
    node.src = 'https://checkout.razorpay.com/v1/checkout.js'
    node.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(node);
  }
  toggleMenu() {
    if (this.toggle?.length) {
      this.toggle[0].classList.remove("sidebar-lg-show");//.click();

    } else {
      this.toggle = document.getElementsByTagName('body');
    }
  }


  changeViewOfPasswrd(FOR, typeForPassword) {
    if (typeForPassword == 'password') {
      if (FOR == 'currpass') {
        this.typeForCurrPassword = 'text';
      } else if (FOR == 'pass') {
        this.typeForPassword = 'text';
      } else if (FOR == 'conpass') {
        this.typeForConPassword = 'text';
      }
    } else {
      if (FOR == 'currpass') {
        this.typeForCurrPassword = 'password';
      } else if (FOR == 'pass') {
        this.typeForPassword = 'password';
      } else if (FOR == 'conpass') {
        this.typeForConPassword = 'password';
      }
    }
  }

  logout() {
    this.dataManipSrvc.apiToken = "";
    setTimeout(() => {
      location.reload();
    }, 90);
  }

}
